module.exports = __webpack_public_path__ + "static/img/Royal-Derby.f17923d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Royal-Derby.jpg
// module id = CVcf
// module chunks = 0